<template>
  <v-container>
    <date-selecter
      v-model="date"
      :currentFilter="'tomorrow'"
      @changeDate="onDateChanged"
      :availableOptions="'future'"
    ></date-selecter>

    <div class="text-xs-right">
      <v-btn outline color="grey" @click="onExport" :loading="loading">Export</v-btn>
    </div>

    <v-data-table
      :rows-per-page-items="[25, 40, 50, 100]"
      :loading="loading"
      :headers="headers"
      :items="orders"
      class="elevation-1"
    >
         <template v-slot:items="{item}">
             <template v-if="item">
                <td>{{item.name}} ({{item.option}})</td>
                <td class="text-xs-center">{{item.quantity}}</td>
             </template>
         </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DateSelecter from '@/components/elements/DateSelecter.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      date: null,
      headers: [{value: 'name', text: 'ชื่อ'}, {value: 'quantity', text: 'จำนวน', align: 'center'}],
      orders: [],
      loading: true
    }
  },
  components: {
    DateSelecter
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    // this.orders = await this.getAliceProductAmount()
  },
  methods: {
    onExport() {
      let json = cloneDeep(this.orders)

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'ยอดสั่งซื้อตามวัน.xlsx')

    },
    async getAliceProductAmount() {
      try {
        var { result } = await api.getAliceProductAmount({
          pageid: this.selectedBot.pageid,
          datefrom: this.date.start,
          dateto: this.date.end
        })

        return result
      } catch (error) {
        console.error(error)
      }
    },
    async onDateChanged() {
      this.loading = true
      this.orders = await this.getAliceProductAmount()
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Orderdaily.vue